// extracted by mini-css-extract-plugin
export default {"wrapper":"Step9c_wrapper__jtDYT","box":"Step9c_box__ZmhJR","leftColumn":"Step9c_leftColumn__PcXJ+","boxItem":"Step9c_boxItem__TjImb","list":"Step9c_list__TNbln"};